<template>
  <b-modal title="Manage dashboard" class="modal-light" v-model="showModal" @ok="submit" size="lg">
    <b-tabs>
      <b-tab title="Settings" active>
        <b-row>
          <b-col sm='4'>Dashboard name:</b-col>
          <b-col sm='8'>
            <b-form-input type='text' placeholder='Enter dashboard name' v-model='dashboardName'></b-form-input>
          </b-col>
        </b-row>
        <br>
        <share-select ref='usersSelect' />
        <br>
        <client-groups-select ref='groupsSelect' />
        <br>
        <b-row>
          <b-col sm='4'>Access level:</b-col>
          <b-col sm='8'>
            <v-select class='select-no-caret' v-model='accessLevel' :options="accessLevels"/>
          </b-col>
        </b-row>
        <template v-if="currentUser.isAdmin || (currentUser.id === ownerId)">
          <br>
          <b-row>
            <b-col sm='4'>Lock dashboard:</b-col>
            <b-col sm='8'>
              <b-check class='select-no-caret' v-model='locked' />
            </b-col>
          </b-row>
        </template>
      </b-tab>
      <b-tab title="Audits" v-if="mode === 'edit'">
        <Audits :audits="dashboard"/>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import ShareSelect from '@/views/base/ShareSelect'
import ClientGroupsSelect from '@/views/base/ClientGroupsSelect'
import Audits from '@/views/pages/Audits'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'DashboardModal',
  components: {
    ShareSelect,
    ClientGroupsSelect,
    vSelect,
    Audits
  },

  created () {
    this.$eventBus.$on('editDashboardModal', (dashboard) => this.initEditMode(dashboard))
    this.$eventBus.$on('newDashboardModal', () => this.initCreateMode())
    this.$eventBus.$on('copyDashboardModal', (dashboard) => this.initCopyMode(dashboard))
  },

  beforeDestroy(){
    this.$eventBus.$off('editDashboardModal')
    this.$eventBus.$off('newDashboardModal')
    this.$eventBus.$off('copyDashboardModal')
  },

  data () {
    return {
      title: null,
      showModal: false,
      dashboardId: null,
      dashboardName: null,
      mode: null,
      locked: false,
      ownerId: null,
      accessLevel: 'digital',
      accessLevels: ['digital', 'agency', 'client', 'client_specific']
    }
  },

  computed: {
    ...mapGetters(['currentUser', 'dashboard']),
    params () {
      return {
        name: this.dashboardName,
        share_with: this.$refs.usersSelect.sharedUsers,
        shared_client_groups: this.$refs.groupsSelect.clientGroups,
        locked: this.locked,
        access_level: this.accessLevel
      }
    }
  },

  methods: {
    ...mapActions([
      'getDashboard'
    ]),

    initCreateMode () {
      this.reset()
      this.mode = 'create'
      this.showModal = true
    },

    initCopyMode (dashboard) {
      this.reset()
      this.dashboardName = dashboard.attributes.name
      this.dashboardId = dashboard.id
      this.locked = dashboard.attributes.locked
      this.ownerId = dashboard.attributes.owner_id
      this.accessLevel = dashboard.attributes.access_level
      this.mode = 'copy'
      this.showModal = true
      this.loadSharedUsers()
      this.loadSharedGroups()
    },

    initEditMode (dashboard) {
      this.reset()
      this.mode = 'edit'
      this.getDashboard(dashboard.id)
      this.dashboardName = dashboard.attributes.name
      this.dashboardId = dashboard.id
      this.locked = dashboard.attributes.locked
      this.ownerId = dashboard.attributes.owner_id
      this.accessLevel = dashboard.attributes.access_level
      this.showModal = true
      this.loadSharedUsers()
      this.loadSharedGroups()
    },

    loadSharedGroups () {
      this.$http.get('/dashboards/' + this.dashboardId + '/client_groups')
        .then(function(response){
          this.$refs.groupsSelect.clientGroups = response.data
        }.bind(this))
    },

    loadSharedUsers () {
      var self = this
      this.$http.get('/dashboards/' + this.dashboardId + '/users')
        .then(function(response){
          response.data.forEach(function(user){
            if (user.email !== self.$store.getters.currentUser.email){
              self.$refs.usersSelect.sharedUsers.push(user.email)
            }
          })
        })
    },

    submit () {
      if (this.mode === 'create') {
        this.createDashboard()
      } else if (this.mode === 'edit') {
        this.updateDashboard()
      } else if (this.mode === 'copy') {
        this.copyDashboard()
      }
    },

    copyDashboard () {
      this.showModal = false
      this.params.copy_dashboard_id = this.dashboardId
      this.$http.post('/dashboards', this.params)
        .then(function(response){
          this.dashboardName = null
          this.$parent.dashboards.push(response.data.data)
        }.bind(this))
    },

    updateDashboard () {
      this.showModal = false
      this.$http.patch('/dashboards/' + this.dashboardId, this.params)
        .then(function(){
          var parentDashboard = this.findById(this.dashboardId)
          parentDashboard.attributes.name = this.dashboardName
          parentDashboard.attributes.locked = this.locked
          this.dashboardName = null
          this.dashboardId = null
          this.locked = false
        }.bind(this))
    },

    createDashboard () {
      this.$http.post('/dashboards', this.params)
        .then(function(response){
          this.dashboardName = null
          this.$parent.dashboards.push(response.data.data)
        }.bind(this))
    },

    findById (id) {
      return this.$parent.dashboards.find(dashboard => dashboard.id === id)
    },

    reset () {
      this.$refs.usersSelect.sharedUsers = []
      this.$refs.groupsSelect.clientGroups = []
      this.dashboardName = null
      this.dashboardId = null
      this.locked = false
      this.ownerId = null
      this.accessLevel = 'digital'
      this.copyDashboardId = null
    }
  }

}
</script>

<style>
  .modal-body div > input[type="text"] {
    padding: 4px 7px;
    border-radius: 4px;
    border: 1px solid rgba(60,60,60,.26);
  }
</style>
